<template>
  <div
    class="ug-table-header-cell"
    :style="style"
    data-cy="ug-table-header-cell"
    @click="onClick"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class UgTableHeaderCell extends Vue {
  @Prop({ type: String, default: "auto" })
  width!: string;

  @Emit("click")
  onClick() {}

  get style() {
    return {
      width: this.width
    };
  }
}
</script>

<style lang="scss" scoped>
.ug-table-header-cell {
  display: table-cell;
  padding: 10px;
  height: 52px;
  background-color: $colorBlue800;
  color: white;
  vertical-align: middle;
  text-align: center;
  font-weight: bold;

  @include default-break-word();

  &:first-child {
    border-top-left-radius: $sizeRadius;
  }
  &:last-child {
    border-top-right-radius: $sizeRadius;
  }
}
</style>
